export type Modal = {
  id: string;
  resource_id?: string;
  resource_type?: string;
  meta?: object;
};

export enum ModalId {
  DeleteComment = 'deleteComment',
  AttachmentPreview = 'attachmentPreview',
  CardActionConfirm = 'confirmActionModal',
}
